'use strict';

import Component from 'generic.basecomponent';
import $ from 'jquery';
import basketManager from './basket-manager';

export default class ShopBundle extends Component {
    constructor(el) {
        super(el);
        this.addButtonSelector = '.js-shop-bundle-add';
        this.itemSelector = '.js-shop-bundle-item';
        this.itemOptionSelector = '.js-shop-bundle-item-option';
        this.inProgress = false;
        this.items = [];
        this.init();
    }

    getEndpointUrl() {
        return '/api/shoppingcart/addbundle';
    }

    init() {
        this.itemId = this.container.getAttribute('data-shop-bundle-id');
        this.addButton = this.container.querySelector(this.addButtonSelector);
        if (!this.addButton) {
            return;
        }

        let items = [...this.container.querySelectorAll(this.itemSelector)];
        for (let i in items) {
            let item = items[i];
            let itemId = item.getAttribute('data-shop-bundle-item-id');

            if (itemId) {
                let optionsData = [];
                let options = [...item.querySelectorAll(this.itemOptionSelector)];
                for (let j in options) {
                    let option = options[j];
                    let optionId = option.getAttribute('data-shop-bundle-item-option-id');
                    if (optionId) {
                        optionsData.push({id: optionId, element: option});
                    }
                }
                this.items.push({
                    id: itemId,
                    options: optionsData
                })
            }
        }

        this.addButton.addEventListener('click', this.onAddButtonClick.bind(this));
    }

    onAddButtonClick(e) {
        if (!this.inProgress) {
            this.inProgress = true;
            this.addButton.classList.add('is-loading');

            let body = this.getRequestBody();
            this.doAddRequest(body).then((result) => {
                basketManager.proceedSuccessAddToCart(result);
            }, (error) => {
                basketManager.proceedCartOperationError(error);
            }).then(() => {
                this.inProgress = false;
                this.addButton.classList.remove('is-loading');
            })
        }
    }

    doAddRequest(body, params = {}) {
        return new Promise((resolve, reject) => {
            $.ajax({
                method: "post",
                url: this.getUrl(params),
                data: body
            }).done((response) => {
                resolve(response);
            }).fail((error) => {
                reject(error);
            });
        });
    }

    getUrl(params) {
        let paramsString = Object.keys(params).map(key => `${key}=${params[key]}`).join('&');
        return `${this.getEndpointUrl()}` + (paramsString !== '' ? `?${paramsString}` : '');
    }

    getRequestBody() {
        return {
            Id: this.itemId,
            Products: this.getItems()
        };
    }

    getItems() {
        return this.items.reduce((itemsResult, itemData) => {
            let item = {
                Id: itemData.id
            };
            let options = basketManager.prepareItemOptions(itemData.options);
            if (options.length) {
                item.Options = options;
            }
            itemsResult.push(item);
            return itemsResult;
        }, []);
    }
}

ShopBundle.id = 0;



// WEBPACK FOOTER //
// ./app/components/shop/js/generic.shop-bundle.js